"use client";

import { c as _c } from "react/compiler-runtime";
import { useEvmSignFunction } from "../arch/evm/useEvmSignFunction";
import { useEvmSignTypedFunction } from "../arch/evm/useEvmSignTypedFunction";
import { useSvmSignFunction } from "../arch/svm/useSvmSignFunction";
import { useAccount } from "./useAccount";
/**
 * Signature helper function
 * @returns object:
 *  - sign: function that signs a message
 *  - signTyped: function that signs a typed message
 */
export const useSignature = () => {
  const $ = _c(3);
  const {
    chainArch
  } = useAccount();
  const sign = useSignFunction(chainArch);
  const signTyped = useSignTypedFunction(chainArch);
  let t0;
  if ($[0] !== sign || $[1] !== signTyped) {
    t0 = {
      sign,
      signTyped
    };
    $[0] = sign;
    $[1] = signTyped;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
const useSignFunction = chainArch => {
  const evmSign = useEvmSignFunction();
  const svmSign = useSvmSignFunction();
  switch (chainArch) {
    case "SVM":
      {
        return svmSign;
      }
    default:
      {
        return evmSign;
      }
  }
};
const useSignTypedFunction = chainArch => {
  const evmSignTyped = useEvmSignTypedFunction();
  switch (chainArch) {
    default:
      {
        return evmSignTyped;
      }
  }
};